import React from 'react'

function Stories() {
  return (
    <div className='storybg pb-5'>
      <div className='container-fluid py-5'>
        <h1 className='text-start pt-5 pb-3 fw-normal text-light'>Our travel stories</h1>
        <div className='row'>
            <div className='col-lg-6'>
                <img className='w-100' src={require('../image/f1.jpg')}/>
                <div className='row my-4'>
                    <div className='col-lg-6'><img className='w-100' src={require('../image/f3.jpg')}/></div>
                    <div className='col-lg-6'><img className='w-100' src={require('../image/f4.jpg')}/></div>
                </div>
            </div>
            <div className='col-lg-6'>
                <img className='w-100' height={365} src={require('../image/f2.jpg')}/>
                <img className='w-100 my-4' src={require('../image/f5.jpg')}/>
            </div>
        </div>
        </div>
    </div>
  )
}

export default Stories
